import type { CSSProperties } from 'react';
import { Box, Image, Link } from '@chakra-ui/react';
import kofiButton from '../images/kofi-button.png';
import kofiSymbol from '../images/kofi-symbol.png';
import { KOFI_URL } from '../constants/support';
import { RiftboundButton } from './ui/button';

const graphicLinkStyle: CSSProperties = {
  width: '100%',
  maxWidth: '170px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  outline: 'none',
};

export type SupportDonationButtonLayout = 'graphic' | 'inline';

export interface SupportDonationButtonProps {
  /**
   * `graphic`: official Ko-fi wide image (modal, donation section).
   * `inline`: compact chip with mug logo + label — fits full-width footer on mobile without heavy height.
   */
  layout?: SupportDonationButtonLayout;
}

/** Ko-fi CTA — default wide graphic, or a slim icon + text row (`layout="inline"`). */
export function SupportDonationButton({ layout = 'graphic' }: SupportDonationButtonProps) {
  if (layout === 'inline') {
    return (
      <RiftboundButton
        as={'a' as never}
        {...({
          href: KOFI_URL,
          target: '_blank',
          rel: 'noopener noreferrer',
        } as Record<string, unknown>)}
        treatment="secondary"
        size="xs"
        w="100%"
        minH="34px"
        px={3}
        py={1.5}
        gap={2}
        fontSize="sm"
        fontWeight="semibold"
        justifyContent="center"
        borderRadius="md"
      >
        <Image src={kofiSymbol} alt="" boxSize="16px" objectFit="contain" flexShrink={0} draggable={false} />
        <Box as="span" lineHeight="short">
          Support on Ko-fi
        </Box>
      </RiftboundButton>
    );
  }

  return (
    <Link href={KOFI_URL} target="_blank" rel="noopener noreferrer" style={graphicLinkStyle}>
      <Image w="100%" h="auto" minH="32px" src={kofiButton} alt="Support on Ko-fi" />
    </Link>
  );
}
